<template>
  <div class="case-digital-mlpa-main-page col-block width-full">
    <template v-if="projectID.startsWith('date-')">
      <mainUpload
        @create="data => $emit('create', data)"
      ></mainUpload>
    </template>
    <template v-else>
      <mainData
        :projects="projects"
        :projectID="projectID"
      ></mainData>
    </template>
  </div>
</template>

<script>
import mainUpload from './mainUpload.vue'
import mainData from './mainData.vue'

export default {
  components: {
    mainUpload,
    mainData
  },
  props: {
    projects: {
      type: Array,
      required: true
    },
    projectID: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/digitalMLPA/main.vue